// Used in Keyword search
import React, { useState, useRef, useEffect } from "react";
import TopicBucket from "./TopicBucket";

// This is now also used for TopicSearchResults
export default function KeywordSearchResults({
  results,
  userList,
  handleUserListUpdate,
  topics,
  setTopics,
  isKeywordSearch,
  isMobile,
  keyword,
  numResults,
}) {
  const activeTopicCount = topics.filter((topic) => topic.active).length;
  const isAgencySearch = window.location.search.includes("type=agency");
  const hiddenResultsCount = numResults - results.length;
  const topicText = isAgencySearch ? "" :
    topics.length > 1
      ? `${topics.length > 0 && " in " + activeTopicCount} topics`
      : results.length > 0
      ? ` in ${topics && topics[0] && topics[0].name}`
      : "";
  return (
    <div className="content content--wide">
      <div className="resource-list resource-buckets">
        <div className="resource-list-header">
          <h2>
            Showing {results.length}
            {results.length == 1 ? " result" : " results"}
            {isKeywordSearch && keyword.length > 0 && ` for "${keyword}"`}
            {topicText}.
            {hiddenResultsCount > 0 && ` ${hiddenResultsCount} more hidden by filters.`}
          </h2>
        </div>
        <TopicBucket
          resources={results}
          userList={userList}
          handleUserListUpdate={handleUserListUpdate}
          topics={topics}
          setTopics={setTopics}
          isMobile={isMobile}
        />
      </div>
    </div>
  );
}
